export const translations = {
  id: {
    // Common
    loading: "Memuat...",
    
    // Admin Dashboard Specific Keys  
    adminDashboardDesc: "Kelola sistem dan pantau aktivitas pengguna",
    requestStatusSummary: "Ringkasan Status Permintaan",
    recentRequests: "Permintaan Terbaru", 
    recentClients: "Klien Terbaru",
    totalClients: "Total Klien",
    activeClients: "Klien Aktif",
    totalRequests: "Total Permintaan",
    pendingRequests: "Permintaan Menunggu",
    
    // Status translations for charts
    menunggu: "Menunggu",
    disetujui: "Disetujui", 
    ditolak: "Ditolak",
    
    // Admin Notification Keys
    enableDesktopNotifications: "Aktifkan Notifikasi Desktop",
    getRealtimeAlerts: "Dapatkan alert real-time untuk permintaan baru, pembayaran, dan pesan bahkan ketika browser tidak aktif",
    clientDashboard: "Dashboard Klien",
    failedToLoadData: "Gagal memuat data dashboard",
    
    // Enhanced Notification Keys
    enableNotifications: "Aktifkan Notifikasi Desktop",
    notificationDescription: "Dapatkan update real-time tentang permintaan akun, pembayaran, dan status lainnya dengan suara keras",
    enable: "Aktifkan",
    enabling: "Mengaktifkan...",
    notificationsEnabled: "Notifikasi Berhasil Diaktifkan!",
    notificationsDenied: "Notifikasi Ditolak",
    notificationsEnabledDesc: "Anda akan mendapat notifikasi untuk semua update penting dengan suara yang keras.",
    notificationsDeniedDesc: "Anda bisa mengaktifkan notifikasi kapan saja di pengaturan browser.",
    
    // Real-time notification messages  
    newAccountRequest: "Permintaan Akun Baru",
    accountApproved: "Akun Disetujui",
    accountRejected: "Akun Ditolak", 
    accountCompleted: "Akun Selesai",
    paymentReceived: "Pembayaran Diterima",
    paymentConfirmed: "Pembayaran Dikonfirmasi",
    withdrawalProcessed: "Penarikan Diproses",
    shareRequestReceived: "Permintaan Share Diterima",
    
    // MASSIVE Admin Translation Keys Addition
    
    // Account Management
    deleteAccount: "Hapus Akun",
    updateStatus: "Perbarui Status",
    viewDetails: "Lihat Detail",
    deleteWarning1: "Akun akan dihapus permanen",
    deleteWarning2: "Klien akan kehilangan akses segera",
    deleteWarning3: "Riwayat transaksi akan tetap disimpan",
    deleteWarning4: "Tidak dapat menghapus akun dengan saldo positif",
    activateWarning: "Mengaktifkan akan mengembalikan akses penuh akun.",
    disableWarning: "Menonaktifkan akan mencegah klien menggunakan akun ini.",
    suspendWarning: "Menangguhkan akan membatasi akses akun sementara.",
    deleteWarning: "Peringatan: Aksi ini tidak dapat dibatalkan!",
    statusChangeWarning: "Peringatan Perubahan Status",
    cannotDelete: "Tidak Dapat Menghapus:",
    positiveBalance: "Akun memiliki saldo positif sebesar",
    accountInfo: "Informasi Akun",
    newStatus: "Status Baru",
    searchAccounts: "Cari akun, klien, atau ID akun...",
    accountDetails: "Detail Akun",
    createdDate: "Dibuat",
    fee: "Biaya %",
    updateAccountStatus: "Perbarui Status Akun",
    deleting: "Menghapus...",
    filterByPlatform: "Filter berdasarkan Platform",
    filterByStatus: "Filter berdasarkan Status",
    totalBalance: "Total Saldo",
    manageAdAccounts: "Kelola akun iklan, status, dan pengaturan",
    loadingAccounts: "Memuat akun...",
    errorDeletingAccount: "Gagal menghapus akun",
    errorFetchingAccounts: "Gagal memuat akun",
    accountDeleted: "Akun berhasil dihapus",
    
    // Admin Dashboard
    noRecentClients: "Tidak ada klien terbaru",
    noRecentRequests: "Tidak ada permintaan terbaru",
    
    // Admin Layout
    superAdmin: "Super Admin",
    admin: "Admin",
    
    // Admin Login
    allFieldsRequired: "Semua kolom wajib diisi",
    
    // Admin Management  
    activate: "Aktifkan",
    deactivate: "Nonaktifkan",
    notSet: "Belum diatur",
    createAdmin: "Buat Admin",
    creating: "Membuat...",
    updateAdmin: "Perbarui Admin",
    cannotChangeOwnRole: "(Tidak dapat mengubah peran sendiri)",
    enterWhatsappNumber: "contoh: +628123456789",
    makeSuperAdmin: "Jadikan Super Admin",
    whatsappNumber: "Nomor WhatsApp",
    createNewAdmin: "Buat Admin Baru",
    created: "Dibuat",
    editAdmin: "Edit Admin",
    whatsapp: "WhatsApp",
    noAdmins: "Tidak ada pengguna admin ditemukan",
    manageAdminUsers: "Kelola pengguna admin dan izin mereka",
    adminList: "Daftar Admin",
    failedToCreateAdmin: "Gagal membuat admin",
    failedToDeleteAdmin: "Gagal menghapus admin",
    failedToLoadAdmins: "Gagal memuat admin",
    failedToUpdateAdmin: "Gagal memperbarui admin",
    passwordTooShort: "Kata sandi minimal 6 karakter",
    adminCreated: "Admin berhasil dibuat",
    adminDeleted: "Admin berhasil dihapus",
    adminStatusUpdated: "Status admin berhasil diperbarui",
    adminUpdated: "Admin berhasil diperbarui",
    confirmDeleteAdmin: "Apakah Anda yakin ingin menghapus admin ini?",
    
    // Admin Profile
    includeLettersNumbers: "Sertakan huruf dan angka",
    minSixChars: "Minimal 6 karakter",
    accountType: "Tipe Akun",
    changing: "Mengubah...",
    enterFullName: "Masukkan nama lengkap Anda",
    memberSince: "Anggota sejak",
    passwordRequired: "Kata sandi diperlukan untuk menyimpan perubahan profil",
    whatsappNumberHint: "Digunakan untuk notifikasi penting dan peringatan",
    manageAdminAccount: "Kelola informasi akun admin dan pengaturan keamanan Anda",
    profileInformation: "Informasi Profil",
    failedToChangePassword: "Gagal mengubah kata sandi",
    failedToUpdateProfile: "Gagal memperbarui profil",
    passwordsDoNotMatch: "Kata sandi tidak cocok",
    
    // Client Detail
    noRequests: "Belum ada permintaan akun",
    noTransactions: "Belum ada transaksi",
    totalTopUp: "Total Top Up",
    totalTransactions: "Total Transaksi",
    totalWithdraw: "Total Penarikan",
    accountRequests: "Permintaan Akun",
    backToClients: "Kembali ke Klien",
    clientDetail: "Detail Klien",
    transactionHistory: "Riwayat Transaksi",
    clientNotFound: "Klien tidak ditemukan",
    failedToLoadClient: "Gagal memuat detail klien",
    
    // Client Edit
    clientActive: "Klien aktif",
    saveChanges: "Simpan Perubahan",
    saving: "Menyimpan...",
    enterCompanyName: "Masukkan nama perusahaan",
    enterDisplayName: "Masukkan nama tampilan",
    clientActiveDesc: "Hapus centang untuk menonaktifkan akun klien ini",
    editingClientProfile: "Mengedit profil dan pengaturan klien",
    backToDetail: "Kembali ke Detail",
    clientInformation: "Informasi Klien",
    failedToUpdateClient: "Gagal memperbarui klien",
    clientUpdated: "Klien berhasil diperbarui",
    
    // Financial Reports
    financialReports: "Laporan Keuangan",
    
    // Transfer Request Management  
    transferRequestManagement: "Manajemen Transfer Saldo",
    
    // Client Management
    editClient: "Edit",
    resetPassword: "Reset Kata Sandi",
    viewHistory: "Riwayat",
    balance: "Saldo",
    noClientsMatchFilter: "Tidak ada klien yang sesuai dengan filter saat ini",
    results: "hasil",
    firstPage: "Halaman Pertama",
    lastPage: "Halaman Terakhir",
    nextPage: "Halaman Selanjutnya",
    prevPage: "Halaman Sebelumnya",
    failedToResetPassword: "Gagal reset kata sandi",
    
    // Notification Bell
    marking: "Menandai...",
    viewAll: "Lihat semua notifikasi",
    failedToMarkRead: "Gagal menandai notifikasi sebagai sudah dibaca",
    allNotificationsRead: "Semua notifikasi ditandai sudah dibaca",
    hoursAgo: "j lalu",
    minsAgo: "m lalu",
    daysAgo: "h lalu",
    
    // Payment Verification
    downloadInvoice: "Unduh Invoice",
    
    // Request Management  
    disableRequestWarning: "Ini akan menandai permintaan sebagai dinonaktifkan. Karena belum ada akun iklan yang dibuat, ini hanya mempengaruhi status permintaan.",
    requestWillBeMarkedDisabled: "Permintaan akan ditandai sebagai dinonaktifkan",
    disableAccountWarning: "Ini akan menonaktifkan akun dan mencegah klien menggunakannya. Akun dapat diaktifkan kembali nanti jika diperlukan.",
    disableWarningTitle: "Akun akan dinonaktifkan",
    moreRequests: "permintaan lagi",
    deleteAccountWarning: "Ini akan menghapus permanen akun dan semua data terkait. Klien akan kehilangan akses ke akun ini segera.",
    deleteWarningTitle: "Aksi ini tidak dapat dibatalkan",
    enterFeePercentage: "Masukkan persentase biaya (contoh: 5.5)",
    deleteWarningMessage: "Ini akan menghapus permanen akun dan semua data terkait. Pertimbangkan untuk menonaktifkan akun jika Anda ingin menyimpan data.",
    enterFacebookAccountId: "Masukkan ID Akun Facebook (contoh: 123456789)",
    clientNotes: "Catatan Klien",
    currentStatus: "Status Saat Ini",
    facebookAccountId: "ID Akun Facebook",
    facebookAccountIdHint: "ID akun Facebook Ads aktual yang akan diberikan kepada klien",
    feePercentageHint: "Persentase biaya yang akan ditambahkan ke top-up klien (0-100%)",
    processedBy: "Diproses Oleh",
    requestDate: "Tanggal Permintaan",
    bulkApprovalWarning: "Catatan: Permintaan Facebook Ads akan dilewati dalam persetujuan massal dan harus diproses individual dengan ID Akun",
    requestsSelected: "permintaan terpilih",
    noRequestsMessage: "Coba sesuaikan pencarian atau filter Anda",
    addBulkNotesOptional: "Tambah catatan untuk semua permintaan terpilih (opsional)...",
    addNotesOptional: "Tambah catatan (opsional)...",
    selectStatus: "Pilih Status",
    clientInformation: "Informasi Klien",
    requestInfo: "Informasi Permintaan",
    selectedRequests: "Permintaan Terpilih",
    bulkUpdate: "Perbarui Massal",
    bulkUpdateRequests: "Perbarui Permintaan Massal",
    every10Seconds: "Setiap 10 detik",
    requestDetails: "Detail Permintaan",
    updateRequestStatus: "Perbarui Status Permintaan",
    searchRequests: "Cari permintaan...",
    manageAccountRequests: "Kelola permintaan akun iklan dari klien",
    accountDisabledSuccess: "Akun berhasil dinonaktifkan",
    requestMarkedDisabled: "Permintaan berhasil ditandai dinonaktifkan",
    accountCompletedSuccess: "Akun berhasil diselesaikan dan diaktifkan",
    requestApprovedSuccess: "Permintaan berhasil disetujui",
    requestRejectedSuccess: "Permintaan berhasil ditolak",
    feePercentageRequired: "Persentase biaya yang valid (0-100%) diperlukan untuk persetujuan",
    accountDeletedSuccess: "Akun berhasil dihapus",
    requestDeletedSuccess: "Permintaan berhasil dihapus",
    errorUpdatingStatus: "Gagal memperbarui status",
    requestStatusUpdated: "Status permintaan berhasil diperbarui",
    errorFetchingRequests: "Gagal memuat permintaan",
    facebookAccountIdRequired: "ID Akun Facebook diperlukan untuk persetujuan",
    pleaseSelectRequests: "Silakan pilih permintaan untuk diperbarui",
    deleted: "Dihapus",
    
    // Reset Password Modal
    clientMustChangePassword: "Klien harus mengubah kata sandi saat login berikutnya",
    newPasswordGenerated: "Kata sandi sementara baru akan dibuat",
    newPasswordWillBeShown: "Kata sandi baru akan ditampilkan hanya sekali",
    important: "Penting",
    resetPasswordConfirm: "Apakah Anda yakin ingin mereset kata sandi untuk",
    resetting: "Mereset...",
    resetPassword: "Reset Kata Sandi",
    
    // Share Request Management
    shareTarget: "Target Share",
    noShareRequestsFound: "Tidak ada permintaan share ditemukan",
    noShareRequestsMessage: "Coba sesuaikan pencarian atau filter Anda",
    shareRequestInfo: "Informasi Permintaan Share",
    shareRequestDetails: "Detail Permintaan Share",
    updateShareRequestStatus: "Perbarui Status Permintaan Share",
    totalShareRequests: "Total Permintaan Share",
    searchShareRequests: "Cari permintaan share...",
    manageShareRequests: "Kelola permintaan share akun dari klien",
    shareRequestManagement: "Manajemen Permintaan Share",
    errorFetchingShareRequests: "Gagal memuat permintaan share",
    shareRequestStatusUpdated: "Status permintaan share berhasil diperbarui",
    
    // Withdraw Management
    processRequest: "Proses Permintaan",
    rejectWithdrawWarning: "Menolak akan membatalkan permintaan penarikan tanpa perubahan saldo.",
    approveWithdrawWarning: "Menyetujui akan mengurangi jumlah yang diverifikasi dari saldo akun dan menambahkannya ke wallet pengguna.",
    uploading: "Mengunggah...",
    clickToUploadProof: "Klik untuk mengunggah screenshot bukti saldo",
    enterVerifiedAmount: "Masukkan jumlah yang diverifikasi",
    processedAt: "Diproses Pada",
    withdrawProcessingNote: "Penting",
    accountBalance: "Saldo Akun",
    uploadBalanceProof: "Unggah Bukti Saldo",
    requestedAmount: "Jumlah Diminta",
    verifiedAmount: "Jumlah Diverifikasi",
    verifiedAmountHelp: "Masukkan saldo aktual yang diverifikasi dari akun",
    noWithdrawsFound: "Tidak ada permintaan penarikan ditemukan",
    noWithdrawsMessage: "Coba sesuaikan pencarian atau filter Anda",
    decision: "Keputusan",
    requestInfo: "Informasi Permintaan",
    searchWithdraws: "Cari penarikan berdasarkan akun, klien...",
    processWithdrawRequest: "Proses Permintaan Penarikan",
    requested: "Diminta",
    verified: "Diverifikasi",
    withdrawDetails: "Detail Penarikan",
    totalApproved: "Total Disetujui",
    manageWithdrawRequests: "Kelola dan setujui permintaan penarikan",
    loadingWithdraws: "Memuat permintaan penarikan...",
    errorUpdatingWithdraw: "Gagal memperbarui status penarikan",
    errorUploadingProof: "Gagal mengunggah bukti saldo",
    verifiedAmountRequired: "Jumlah diverifikasi yang valid diperlukan untuk persetujuan",
    balanceProofUploaded: "Bukti saldo berhasil diunggah",
    withdrawStatusUpdated: "Status penarikan berhasil diperbarui",
    
    // Share Account Enhanced Keys
    allGroups: "Semua Grup",
    clearFilters: "Hapus Filter",
    deliveryMethod: "Metode Pengiriman",
    emailMethod: "Email",
    businessManagerId: "Business Manager ID",
    recipients: "Penerima",
    addRecipient: "Tambah Penerima",
    removeRecipient: "Hapus Penerima",
    enterBmId: "Masukkan BM ID",
    enterEmail: "Masukkan alamat email",
    enterBcId: "Masukkan BC ID",
    recipientRequired: "Minimal satu penerima diperlukan",
    invalidEmailFormat: "Format email tidak valid",
    invalidBmIdFormat: "Format BM ID tidak valid",
    invalidBcIdFormat: "Format BC ID tidak valid",
    deliveryMethodRequired: "Metode pengiriman harus dipilih",
    
    save: "Simpan",
    cancel: "Batal",
    submit: "Kirim",
    refresh: "Segarkan",
    autoRefresh: "Segarkan Otomatis",
    every10Seconds: "Setiap 10 detik",
    logout: "Keluar",
    logoutSuccess: "Berhasil logout",
    login: "Masuk",
    register: "Daftar",
    back: "Kembali",
    next: "Selanjutnya",
    search: "Cari",
    filter: "Filter",
    all: "Semua",
    
    // Auth
    welcome: "Selamat Datang",
    loginToAccount: "Masuk atau daftar untuk melanjutkan",
    username: "Username",
    email: "Email",
    password: "Kata Sandi",
    confirmPassword: "Konfirmasi Kata Sandi",
    enterUsername: "Masukkan username",
    enterEmail: "Masukkan email",
    enterPassword: "Masukkan kata sandi",
    repeatPassword: "Ulangi kata sandi",
    loginSuccess: "Login berhasil!",
    loginFailed: "Login gagal",
    registerSuccess: "Registrasi berhasil! Silakan login.",
    registerFailed: "Registrasi gagal",
    loggingIn: "Masuk...",
    registering: "Mendaftar...",
    loginNow: "Masuk Sekarang",
    registerNow: "Daftar Sekarang",
    
    // App Title
    appName: "Rimuru",
    appTagline: "Kelola akun iklan digital Anda dengan mudah",
    
    // Dashboard
    dashboard: "Dashboard",
    welcomeUser: "Selamat Datang, {username}!",
    manageAdsEasily: "Kelola akun iklan digital Anda dengan mudah",
    
    // Navigation
    requestAccount: "Permintaan Akun",
    topUpBalance: "Isi Saldo",
    topUpHistory: "Riwayat Top Up",
    transactions: "Transaksi",
    withdraw: "Tarik Dana",
    profile: "Profil",
    
    // Payment History
    paymentHistory: "Riwayat Top Up",
    viewAllPayments: "Lihat semua riwayat top up Anda",
    noPayments: "Belum ada riwayat top up",
    failedToLoadPayments: "Gagal memuat riwayat pembayaran",
    proof_uploaded: "Bukti Diupload",
    
    // Stats Cards
    walletBalance: "Saldo Wallet",
    walletIDR: "Wallet IDR",
    walletUSD: "Wallet USD",
    exchangeRate: "Kurs Tukar",
    totalAdsBalance: "Total Saldo Iklan",
    totalAccounts: "Total Akun",
    monthlyTransactions: "Transaksi Bulanan",
    
    // Account Management
    yourAdAccounts: "Akun Iklan Anda",
    manageAllAccounts: "Kelola semua akun iklan digital Anda",
    recentTransactions: "Transaksi Terkini",
    noAccounts: "Belum ada akun iklan",
    noAccountsDesc: "Buat permintaan akun baru untuk memulai",
    viewAllAccounts: "Lihat Semua Akun",
    
    // Request Account
    requestNewAccount: "Permintaan Akun Baru",
    requestAccountDesc: "Ajukan permintaan akun iklan untuk platform yang dibutuhkan",
    selectPlatformAndName: "Pilih Platform dan Nama Akun",
    adPlatform: "Platform Iklan",
    selectAdPlatform: "Pilih platform iklan",
    platform: "Platform",
    selectPlatform: "Pilih platform iklan",
    facebook: "Facebook Ads",
    facebookAds: "Facebook Ads",
    facebookDesc: "Platform iklan Facebook untuk meningkatkan jangkauan bisnis Anda",
    google: "Google Ads", 
    googleAds: "Google Ads",
    googleDesc: "Platform iklan Google untuk meningkatkan visibilitas online",
    tiktok: "TikTok Ads",
    tiktokAds: "TikTok Ads",
    tiktokDesc: "Platform iklan TikTok untuk menjangkau audiens yang lebih muda",
    selectGroup: "Pilih Grup",
    noGroup: "Tanpa Grup", 
    groupSelectHint: "Grup membantu mengorganisir dan mengelola akun Anda",
    sendRequest: "Kirim Permintaan",
    availablePlatforms: "Platform Tersedia",
    yourAccounts: "Akun Anda",
    existingAccountsList: "Daftar akun iklan yang sudah ada",
    
    // Share Account
    shareAccount: "Share Akun",
    shareAccountDescription: "Share akun iklan aktif Anda ke Business Manager, email, atau BC ID yang berbeda",
    activeAccounts: "Akun Aktif Anda",
    activeAccountsDesc: "Klik 'Share' untuk meminta share akun ke target yang berbeda",
    noActiveAccounts: "Tidak Ada Akun Aktif",
    noActiveAccountsDesc: "Anda belum memiliki akun aktif untuk di-share",
    shareRequestsHistory: "Riwayat Permintaan Share",
    noShareRequests: "Tidak Ada Permintaan Share",
    noShareRequestsDesc: "Anda belum membuat permintaan share apapun",
    shareTarget: "Target Share",
    targetBmEmail: "Target BM ID atau Email",
    targetEmail: "Target Email",
    targetBcId: "Target BC ID",
    enterBmIdEmail: "Masukkan BM ID atau alamat email",
    enterEmail: "Masukkan alamat email",
    enterBcId: "Masukkan BC ID",
    bmIdEmailRequired: "BM ID atau Email diperlukan untuk Facebook",
    emailRequired: "Email diperlukan untuk Google Ads",
    bcIdRequired: "BC ID diperlukan untuk TikTok",
    shareRequestSubmitted: "Permintaan share berhasil dikirim",
    errorSubmittingRequest: "Error mengirim permintaan",
    errorFetchingData: "Error memuat data",
    share: "Share",
    optional: "Opsional",
    submitRequest: "Kirim Permintaan",
    submitting: "Mengirim...",
    accountId: "ID Akun",
    
    // Multi-step Share Account
    selectAccounts: "Pilih Akun",
    shareMethod: "Metode Berbagi",
    monitor: "Pantau Status",
    continue: "Lanjutkan",
    previous: "Sebelumnya",
    selectAccountsDescription: "Pilih akun yang ingin Anda bagikan",
    accountsSelected: "akun terpilih",
    deselectAll: "Batalkan Semua",
    selectAll: "Pilih Semua",
    shareMethodDescription: "Masukkan detail untuk berbagi akun ke platform yang sesuai",
    selectedAccounts: "Akun Terpilih",
    facebookShareMethods: "Metode Share Facebook",
    googleShareMethods: "Metode Share Google Ads",
    tiktokShareMethods: "Metode Share TikTok Ads",
    bmId: "BM ID",
    enterBmId: "Masukkan BM ID",
    enterGoogleEmail: "Masukkan Email Google Ads",
    facebookShareNote: "Minimal salah satu (BM ID atau Email) harus diisi untuk Facebook",
    addShareNotes: "Tambahkan catatan untuk permintaan share...",
    shareRequestsSubmitted: "Permintaan Share Berhasil Dikirim",
    monitorShareStatus: "Pantau status permintaan share Anda di bawah ini",
    shareMoreAccounts: "Share Akun Lagi",
    successfullySubmitted: "Berhasil Dikirim!",
    shareRequestsProcessing: "permintaan share telah dikirim dan sedang diproses oleh admin. Anda akan mendapat notifikasi ketika status berubah.",
    submitShareRequests: "Kirim Permintaan",
    facebookShareMethodRequired: "Minimal satu metode share Facebook harus diisi (BM ID atau Email)",
    googleEmailRequired: "Email Google Ads harus diisi",
    tiktokBcIdRequired: "BC ID TikTok harus diisi",
    errorSubmittingRequests: "Gagal mengirim permintaan share",
    
    // Status
    pending: "Menunggu",
    approved: "Disetujui", 
    rejected: "Ditolak",
    processing: "Diproses",
    completed: "Selesai",
    failed: "Gagal",
    active: "Aktif",
    inactive: "Tidak Aktif",
    
    // Transactions
    transactionHistory: "Riwayat Transaksi",
    noTransactions: "Tidak Ada Transaksi",
    noTransactionsDesc: "Belum ada transaksi yang dilakukan",
    topup: "Isi Saldo",
    withdrawal: "Tarik Dana",
    amount: "Jumlah",
    date: "Tanggal", 
    status: "Status",
    
    // Common actions
    view: "Lihat",
    edit: "Edit",
    delete: "Hapus",
    close: "Tutup",
    confirm: "Konfirmasi",
    
    // Currency
    idr: "IDR (Rupiah Indonesia)",
    usd: "USD (Dollar Amerika)",
    currency: "Mata Uang",
    
    // Language
    language: "Bahasa",
    indonesian: "Bahasa Indonesia",
    
    // Terms
    termsAgreement: "Dengan melanjutkan, Anda menyetujui syarat dan ketentuan kami",
    
    // Additional Request Account Keys
    selectGroupPlaceholder: "Pilih grup atau biarkan kosong",
    googleAdsSettings: "Pengaturan Google Ads",
    googleAdsCurrencyNote: "Mata uang tetap untuk Google Ads, tidak bisa diubah",
    googleAdsAccounts: "Akun Google Ads",
    
    // Notifications
    notifications: "Notifikasi",
    allNotificationsMarkedRead: "Semua notifikasi ditandai sudah dibaca",
    errorMarkingNotifications: "Gagal menandai notifikasi sebagai sudah dibaca",
    justNow: "Baru saja",
    markAllRead: "Tandai semua sudah dibaca",
    noNotifications: "Tidak ada notifikasi",
    noNotificationsMessage: "Anda sudah melihat semua notifikasi!",
    viewAllNotifications: "Lihat semua notifikasi",
    
    // Common errors and messages
    failedToLoadAccounts: "Gagal memuat akun",
    selectAccountFirst: "Silakan pilih akun terlebih dahulu",
    
    // Form fields
    enterBMId: "Masukkan BM ID",
    selectCurrency: "Pilih mata uang",
    selectGMT: "Pilih GMT",
    bmIds: "BM ID",
    addRecipient: "Tambah Penerima",
    currency: "Mata Uang",
    gmt: "GMT",
    businessManagerId: "Business Manager ID",
    
    // Missing Request Account Keys
    groupSelectHintFacebook: "Grup membantu mengorganisir dan mengelola akun Facebook Anda",
    groupSelectHintGoogle: "Grup membantu mengorganisir dan mengelola akun Google Ads Anda",
    groupSelectHintTiktok: "Grup membantu mengorganisir dan mengelola akun TikTok Anda",
    facebookSettings: "Pengaturan Facebook",
    regionalPresets: "Preset Regional",
    flexibleSettings: "Pengaturan Fleksibel",
    shareGMT: "Bagikan GMT",
    shareCurrency: "Bagikan Mata Uang",
    shareDeliveryMethod: "Bagikan Metode Pengiriman",
    selectDeliveryMethod: "Pilih Metode Pengiriman",
    facebookAccounts: "Akun Facebook",
    accountName: "Nama Akun",
    accountNamePlaceholder: "Masukkan nama akun",
    usingSharedDeliveryMethod: "Menggunakan metode pengiriman bersama",
    addAnotherAccount: "Tambah Akun Lain",
    account: "Akun",
    deliveryMethod: "Metode Pengiriman",
    emailMethod: "Email",
    notes: "Catatan",
    notesPlaceholder: "Tambahkan catatan (opsional)",
    website: "Website",
    websiteHint: "URL lengkap website yang akan dipromosikan",
    websitePlaceholder: "https://www.contoh.com",
    bcId: "BC ID",
    bcIdPlaceholder: "Masukkan BC ID TikTok Business Center",
    shareBcId: "Bagikan BC ID",
    sharedBcId: "BC ID Bersama",
    tiktokAdsSettings: "Pengaturan TikTok Ads",
    tiktokAdsAccounts: "Akun TikTok Ads",
    addTiktokAccount: "Tambah Akun TikTok",
    tiktokAccountPlaceholder: "Masukkan nama akun TikTok Ads",
    tiktokUsdNote: "TikTok Ads menggunakan mata uang USD dan tidak dapat diubah",
    fixedCurrencyUSD: "Mata Uang: USD (Tetap)",
    googleAccount: "Akun Google",
    addGoogleAccount: "Tambah Akun Google",
    googleAccountNamePlaceholder: "Contoh: Google Ads Toko Online",
    googleEmailPlaceholder: "user@domain.com",
    googleEmailNote: "Gunakan email yang belum pernah tertaut dengan Google Ads sebelumnya",
    googleRequestSummary: "Ringkasan Permintaan Google Ads",
    individualSettings: "Pengaturan Individual",
    individualPerAccount: "Individual per Akun",
    individual: "Individual",
    sharedRecipients: "Penerima Bersama",
    totalRequests: "Total Permintaan",
    requestSummary: "Ringkasan Permintaan",
    defaultCurrency: "Mata Uang Default",
    balance: "Saldo",
    totalAccounts: "Total Akun",
    sendingRequest: "Mengirim Permintaan...",
    createFirstAccountHint: "Buat permintaan akun pertama menggunakan form di sebelah kiri",
    groupName: "Nama Grup",
    groupNamePlaceholder: "Contoh: Akun Facebook Toko Online Q4 2024",
    createGroup: "Buat Grup",
    createNewGroup: "Buat Grup Baru",
    createGroupDescription: "Buat grup untuk mengorganisir akun Anda berdasarkan project atau campaign",
    notSelected: "Belum Dipilih",
    emailAddresses: "Alamat Email",
    totalGoogleAccounts: "Total Akun Google",
    totalTiktokAccounts: "Total Akun TikTok",
    accounts: "akun",
    successfullyCreated: "Berhasil membuat",
    failed: "gagal",
    
    // Additional Common Keys
    name: "Nama",
    phoneNumber: "Nomor Telepon",
    address: "Alamat",
    city: "Kota",
    province: "Provinsi",
    enterCity: "Masukkan kota",
    enterProvince: "Masukkan provinsi",
    enterAddress: "Masukkan alamat Anda",
    enterName: "Masukkan nama lengkap Anda",
    enterPhoneNumber: "Masukkan nomor telepon (contoh: 08123456789)",
    passwordMinLength: "Kata sandi minimal 6 karakter",
    passwordMismatch: "Kata sandi tidak cocok",
    addressRequired: "Alamat wajib diisi",
    cityRequired: "Kota wajib diisi",
    nameRequired: "Nama wajib diisi",
    phoneRequired: "Nomor telepon wajib diisi",
    provinceRequired: "Provinsi wajib diisi",
    
    // Dashboard & Profile Keys
    createFirstAccount: "Buat Akun Pertama",
    last5Transactions: "5 Transaksi Terakhir",
    viewAllAccounts: "Lihat Semua Akun",
    viewAllTransactions: "Lihat Semua Transaksi",
    failedToLoadTransactions: "Gagal memuat transaksi",
    suspended: "Suspended",
    disabled: "Nonaktif",
    
    // Profile specific
    profileData: "Data Profil",
    security: "Keamanan",
    personalInformation: "Informasi Pribadi",
    personalInformationDesc: "Perbarui detail dan informasi kontak pribadi Anda",
    profilePicture: "Foto Profil",
    profilePictureDesc: "Unggah foto profil untuk mempersonalisasi akun Anda",
    profilePictureHint: "JPEG, PNG, WebP. Maksimal 5MB.",
    changePassword: "Ubah Kata Sandi",
    changePasswordDesc: "Perbarui kata sandi Anda untuk menjaga keamanan akun",
    displayName: "Nama Tampilan",
    companyName: "Nama Perusahaan",
    enterDisplayName: "Masukkan nama lengkap Anda",
    enterCompanyName: "Masukkan nama perusahaan Anda",
    currentPassword: "Kata Sandi Saat Ini",
    newPassword: "Kata Sandi Baru",
    confirmNewPassword: "Konfirmasi Kata Sandi Baru",
    enterCurrentPassword: "Masukkan kata sandi saat ini",
    enterNewPassword: "Masukkan kata sandi baru",
    confirmNewPassword: "Konfirmasi kata sandi baru",
    currentPasswordHint: "Diperlukan untuk mengkonfirmasi perubahan profil",
    passwordRequirements: "Persyaratan Kata Sandi",
    passwordMinLengthRule: "Minimal 6 karakter",
    passwordSecurityTip: "Gunakan kombinasi huruf, angka, dan karakter khusus",
    updateProfile: "Perbarui Profil",
    updating: "Memperbarui...",
    upload: "Unggah",
    uploading: "Mengunggah...",
    chooseFile: "Pilih File",
    changing: "Mengubah...",
    manageProfileSettings: "Kelola pengaturan akun dan preferensi Anda",
    allFieldsRequired: "Semua kolom wajib diisi",
    currentPasswordRequired: "Kata sandi saat ini diperlukan",
    profileUpdated: "Profil berhasil diperbarui",
    profileUpdateFailed: "Gagal memperbarui profil",
    passwordChanged: "Kata sandi berhasil diubah",
    passwordChangeFailed: "Gagal mengubah kata sandi",
    profilePictureUploaded: "Foto profil berhasil diunggah",
    profilePictureUploadFailed: "Gagal mengunggah foto profil",
    fileTooLarge: "Ukuran file harus kurang dari 5MB",
    invalidFileType: "Hanya gambar JPEG, PNG, dan WebP yang diizinkan",
    
    // Payment & Transaction Keys
    paymentDetails: "Detail Pembayaran",
    totalAmount: "Total Jumlah",
    paymentDate: "Tanggal Pembayaran",
    bankTransferInstructions: "Instruksi Transfer Bank",
    bankTransferDescription: "Silakan transfer jumlah yang tepat ke rekening bank berikut",
    cryptoWalletInstructions: "Instruksi Transfer Crypto Wallet",
    cryptoTransferDescription: "Silakan kirim jumlah yang tepat ke alamat wallet USDT berikut",
    walletAddress: "Alamat Wallet",
    network: "Network",
    accountNumber: "Nomor Rekening",
    importantNotes: "Catatan Penting",
    transferExactAmountNote: "Transfer jumlah yang tepat sesuai yang ditampilkan di atas",
    uploadProofAfterTransfer: "Unggah bukti pembayaran setelah transfer selesai",
    processingTime: "Waktu pemrosesan: 1-24 jam setelah bukti diunggah",
    usdtTrc20Warning: "Kirim hanya USDT di jaringan TRC20 untuk menghindari kehilangan dana",
    uploadPaymentProof: "Unggah Bukti Pembayaran",
    uploadProofDescription: "Unggah screenshot atau foto struk transfer Anda untuk verifikasi pembayaran",
    selectFileType: "Pilih File (JPG, PNG, atau PDF - Maksimal 10MB)",
    paymentProofUploaded: "Bukti Pembayaran Telah Diunggah",
    uploadedAt: "Diunggah pada",
    paymentVerified: "Pembayaran terverifikasi! Saldo akan segera ditambahkan.",
    paymentRejected: "Pembayaran ditolak. Silakan hubungi support.",
    waitingVerification: "Menunggu verifikasi admin...",
    remove: "Hapus",
    
    // Exchange & Currency
    currencyExchange: "Tukar Mata Uang",
    exchangeDescription: "Konversi antara IDR dan USD",
    fromAmount: "Dari Jumlah",
    toAmount: "Ke Jumlah",
    exchange: "Tukar",
    exchanging: "Menukar...",
    
    // Invoice
    downloadInvoice: "Unduh Invoice",
    invoiceDownloaded: "Invoice berhasil diunduh",
    errorDownloadingInvoice: "Error mengunduh invoice",
    
    // Withdraw & Balance Manager Keys
    enterValidAmount: "Masukkan jumlah yang valid",
    amountExceedsBalance: "Jumlah melebihi saldo akun",
    amountExceedsWalletBalance: "Jumlah melebihi saldo wallet",
    minWithdraw: "Jumlah penarikan minimum",
    withdrawRequestSubmitted: "Permintaan penarikan berhasil dikirim. Menunggu persetujuan admin.",
    withdrawFailed: "Penarikan gagal",
    balanceManager: "Kelola Saldo",
    balanceManagerDescription: "Kelola saldo akun dan transfer wallet Anda",
    transferToAccount: "Transfer ke Akun",
    withdrawFromAccount: "Tarik dari Akun",
    walletToAccount: "Transfer Wallet ke Akun",
    transferFromWalletDescription: "Transfer dana dari wallet Anda ke akun iklan",
    selectTargetAccount: "Pilih Akun Target",
    chooseAccount: "Pilih akun",
    transferAmount: "Jumlah Transfer",
    minTransferAmount: "Jumlah transfer minimum adalah",
    enterAmount: "Masukkan jumlah",
    transferNow: "Buat Transfer Request",
    selectedAccount: "Akun Terpilih",
    transferRules: "Aturan Transfer",
    minTransferRule: "Minimum IDR 10.000 atau USD 10",
    currencyMatchRule: "Mata uang transfer harus sesuai dengan mata uang akun",
    instantTransfer: "Saldo ditransfer secara instan",
    requestWithdraw: "Permintaan Penarikan",
    withdrawRequiresApproval: "Permintaan penarikan memerlukan persetujuan admin untuk verifikasi",
    
    // TopUp Keys
    errorFetchingAccounts: "Error memuat akun",
    pleaseSelectAtLeastOneAccount: "Silakan pilih minimal satu akun untuk top up",
    topupFailed: "Top up gagal",
    topUpSummary: "Ringkasan Top Up",
    reviewTopUpDetails: "Tinjau detail top up Anda sebelum transfer",
    editTopUp: "Edit Top Up",
    topUpDetails: "Detail Top Up",
    topUpAmount: "Jumlah Top Up",
    fee: "Biaya",
    subtotal: "Subtotal",
    
    // Admin Keys  
    allStatuses: "Semua Status",
    allPlatforms: "Semua Platform",
    accountStatusUpdated: "Status akun berhasil diperbarui",
    errorUpdatingStatus: "Error memperbarui status",
    pleaseSelectStatus: "Silakan pilih status",
    
    // Additional Important Keys
    view: "Lihat",
    edit: "Edit", 
    delete: "Hapus",
    close: "Tutup",
    confirm: "Konfirmasi",
    actions: "Aksi",
    client: "Klien",
    contact: "Kontak",
    next: "Selanjutnya",
    previous: "Sebelumnya",
    showing: "Menampilkan",
    of: "dari",
    to: "ke",
    results: "hasil",
    itemsPerPage: "Item per halaman",
    registeredDate: "Tanggal Daftar",
    stats: "Statistik",
    status: "Status",
    searchPlaceholder: "Cari berdasarkan nama, email, username...",
    totalClients: "Total Klien",
    activeOnly: "Hanya Aktif",
    allClients: "Semua Klien",
    inactiveOnly: "Hanya Tidak Aktif",
    clientManagement: "Manajemen Klien",
    clientManagementDesc: "Kelola semua klien terdaftar dan status akun mereka",
    searchClients: "Cari Klien",
    showingResults: "Menampilkan hasil",
    noClientsFound: "Tidak ada klien ditemukan",
    noClientsMatchFilter: "Tidak ada klien yang sesuai dengan filter saat ini",
    failedToLoadClients: "Gagal memuat klien",
    clientStatusUpdated: "Status klien berhasil diperbarui",
    failedToUpdateStatus: "Gagal memperbarui status",
    activate: "Aktifkan",
    deactivate: "Nonaktifkan",
    viewHistory: "Lihat Riwayat",
    requests: "Permintaan",
    topup: "Top Up",
    
    // Transaction Page Keys
    viewAllActivities: "Lihat semua aktivitas transaksi Anda",
    filterTransactions: "Filter Transaksi",
    filterBySearch: "Filter berdasarkan pencarian dan kriteria",
    searchTransactions: "Cari Transaksi",
    transactionType: "Jenis Transaksi",
    allTypes: "Semua Jenis",
    allStatus: "Semua Status",
    transactionsList: "Daftar Transaksi",
    transactions: "Transaksi",
    accountRequest: "Permintaan Akun",
    noMatchingTransactions: "Tidak ada transaksi yang sesuai dengan filter",
    tryChangingFilter: "Coba ubah filter pencarian",
    transactionsWillAppear: "Transaksi akan muncul di sini setelah ada aktivitas",
    
    // Additional TopUp Keys
    grandTotal: "Total Keseluruhan",
    totalFee: "Total Biaya",
    transferInformation: "Informasi Transfer",
    amountToTransfer: "Jumlah yang Ditransfer",
    transferMethod: "Metode Transfer",
    bankAccount: "Rekening Bank",
    walletAddress: "Alamat Wallet",
    transferNote: "Silakan transfer jumlah yang tepat sesuai yang ditampilkan di atas. Top up Anda akan diproses setelah konfirmasi transfer.",
    confirmTopUp: "Konfirmasi Top Up",
    topUpTitle: "Top Up Akun",
    
    // Notification Banner
    getInstantNotifications: "Dapatkan Notifikasi Instan",
    neverMissUpdates: "Jangan lewatkan update penting tentang akun iklan, pembayaran, dan permintaan Anda.",
    enableNotifications: "Aktifkan Notifikasi",
    
    // Admin Login & Authentication
    adminLoginDesc: "Akses Dashboard Admin",
    enterUsername: "Masukkan username admin",
    enterPassword: "Masukkan kata sandi admin", 
    loggingIn: "Sedang masuk...",
    defaultAdmin: "Admin Default",
    backToClient: "Kembali ke Dashboard Klien",
    
    // Admin Navigation & Layout
    adminDashboard: "Dashboard Admin",
    clientManagement: "Manajemen Klien",
    requestManagement: "Manajemen Permintaan",
    paymentVerification: "Verifikasi Pembayaran",
    shareRequests: "Permintaan Share",
    shareRequestManagement: "Manajemen Share Request",
    accountManagement: "Manajemen Akun",
    withdrawManagement: "Manajemen Penarikan",
    adminManagement: "Manajemen Admin",
    systemSettings: "Pengaturan Sistem",
    adminProfile: "Profil Admin",
    
    // Admin Dashboard Home
    totalUsers: "Total Pengguna",
    totalRequests: "Total Permintaan",
    totalPayments: "Total Pembayaran",
    totalRevenue: "Total Pendapatan",
    activeUsers: "Pengguna Aktif",
    pendingRequests: "Permintaan Menunggu",
    pendingPayments: "Pembayaran Menunggu",
    recentActivity: "Aktivitas Terbaru",
    systemOverview: "Ikhtisar Sistem",
    
    // Admin Client Management
    clientList: "Daftar Klien",
    addClient: "Tambah Klien",
    editClient: "Edit Klien",
    deleteClient: "Hapus Klien",
    viewClient: "Lihat Klien",
    clientDetails: "Detail Klien",
    clientProfile: "Profil Klien",
    registrationDate: "Tanggal Registrasi",
    lastLogin: "Login Terakhir",
    accountStatus: "Status Akun",
    clientActions: "Aksi Klien",
    
    // Admin Request Management
    requestList: "Daftar Permintaan",
    requestDetails: "Detail Permintaan",
    requestStatus: "Status Permintaan",
    approve: "Setujui",
    reject: "Tolak",
    approveRequest: "Setujui Permintaan",
    rejectRequest: "Tolak Permintaan",
    requestApproved: "Permintaan disetujui",
    requestRejected: "Permintaan ditolak",
    adminNotes: "Catatan Admin",
    addAdminNote: "Tambah Catatan Admin",
    
    // Admin Payment Management
    paymentList: "Daftar Pembayaran",
    paymentDetails: "Detail Pembayaran",
    verifyPayment: "Verifikasi Pembayaran",
    paymentProof: "Bukti Pembayaran",
    paymentAmount: "Jumlah Pembayaran",
    paymentVerified: "Pembayaran Terverifikasi",
    paymentApproved: "Pembayaran Disetujui",
    paymentRejected: "Pembayaran Ditolak",
    
    // Common Admin Actions
    actions: "Aksi",
    edit: "Edit",
    delete: "Hapus",
    view: "Lihat",
    details: "Detail",
    update: "Perbarui",
    create: "Buat",
    save: "Simpan",
    cancel: "Batal",
    confirm: "Konfirmasi",
    yes: "Ya",
    no: "Tidak",
    
    // Admin Form Fields
    fullName: "Nama Lengkap",
    email: "Email",
    username: "Username",
    password: "Kata Sandi",
    confirmPassword: "Konfirmasi Kata Sandi",
    role: "Peran",
    permissions: "Izin",
    createdDate: "Tanggal Dibuat",
    updatedDate: "Tanggal Diperbarui",
    
    // Admin Status & Filters
    allStatuses: "Semua Status",
    active: "Aktif",
    inactive: "Tidak Aktif",
    pending: "Menunggu",
    approved: "Disetujui",
    rejected: "Ditolak",
    completed: "Selesai",
    processing: "Diproses",
    failed: "Gagal",
    suspended: "Ditangguhkan",
    disabled: "Dinonaktifkan",
    
    // Admin Messages & Notifications
    operationSuccessful: "Operasi berhasil",
    operationFailed: "Operasi gagal",
    confirmDelete: "Apakah Anda yakin ingin menghapus?",
    deleteConfirmation: "Konfirmasi Hapus",
    itemDeleted: "Item berhasil dihapus",
    itemUpdated: "Item berhasil diperbarui",
    itemCreated: "Item berhasil dibuat",
    
    // Admin Search & Pagination
    searchPlaceholder: "Cari berdasarkan nama, email, atau username...",
    noResultsFound: "Tidak ada hasil ditemukan",
    showing: "Menampilkan",
    of: "dari",
    items: "item",
    page: "Halaman",
    itemsPerPage: "Item per halaman",
    firstPage: "Halaman Pertama",
    lastPage: "Halaman Terakhir",
    nextPage: "Halaman Selanjutnya",
    prevPage: "Halaman Sebelumnya",
    
    // Additional Admin Keys
    clients: "Klien",
    requests: "Permintaan", 
    loggedOut: "Berhasil logout",
    loading: "Memuat...",
    
    // NEW TopUp Multi-Step Keys
    addBalance: "Isi Saldo",
    balanceDescription: "Isi saldo untuk beberapa akun iklan sekaligus dengan mata uang yang sesuai",
    refreshData: "Segarkan",
    chooseAccounts: "Pilih Akun",
    enterAmounts: "Atur Nominal", 
    paymentSummary: "Ringkasan Bayar",
    chooseAccountsToTopUp: "Pilih akun yang ingin Anda isi saldonya",
    chosenAccounts: "akun terpilih",
    accountNotFound: "Tidak ada akun ditemukan",
    noAccountAvailable: "Tidak Ada Akun Tersedia",
    tryOtherKeyword: "Coba kata kunci pencarian yang berbeda",
    noAccountForCurrency: "Belum ada akun untuk mata uang ini",
    showing: "Menampilkan",
    from: "dari",
    totalAccounts: "akun",
    clearFilter: "Hapus Filter",
    unselectAll: "Batalkan Semua",
    chooseAll: "Pilih Semua",
    chooseCurrency: "Pilih Mata Uang",
    findAccount: "Cari akun berdasarkan nama, platform, atau ID...",
    allGroup: "Semua Grup",
    next: "Lanjutkan", 
    back: "Sebelumnya",
    enterTopUpAmounts: "Tentukan nominal top up untuk setiap akun yang dipilih",
    bulkMode: "Bulk Top Up",
    bulkFeatureDesc: "Atur nominal yang sama untuk semua akun, masih bisa diedit individual",
    applyAll: "Terapkan ke Semua",
    fillAmount: "Nominal Top Up",
    inputAmountFirst: "Masukkan nominal untuk melihat kalkulasi",
    addMoreBalance: "Top Up Lagi",
    balanceDetails: "Detail Top Up",
    sendTo: "Transfer ke",
    totalPayment: "Total Transfer",
    howToPay: "Metode Pembayaran",
    bankAccount: "No. Rekening",
    accountHolder: "Atas Nama",
    submitting: "Memproses...",
    confirmBalance: "Konfirmasi Top Up",
    balance: "Saldo",
    idAccount: "Account ID",
    reviewDetails: "Tinjau detail sebelum melakukan transfer"
  }
};
